import { selectRenderer, createNumberRenderer } from '../components/renderers'
import {
  TextEditor,
  NumberEditor,
  SelectEditor,
  DateEditor,
} from '../components/editors'

const COLUMN_TYPES = {
  TEXT: { renderEditor: TextEditor, renderCell: (value: string) => value },

  NUMBER: {
    renderEditor: NumberEditor,
    renderCell: createNumberRenderer('NUMBER'),
  },
  NUMBER_WITH_COMMAS: {
    renderEditor: NumberEditor,
    renderCell: createNumberRenderer('COMMAS'),
  },
  DOLLAR: {
    renderEditor: NumberEditor,
    renderCell: createNumberRenderer('USD'),
  },
  EURO: {
    renderEditor: NumberEditor,
    renderCell: createNumberRenderer('EUR'),
  },
  RUPEE: {
    renderEditor: NumberEditor,
    renderCell: createNumberRenderer('INR'),
  },
  PERCENT: {
    renderEditor: NumberEditor,
    renderCell: createNumberRenderer('PERCENT'),
  },
  POUND: {
    renderEditor: NumberEditor,
    renderCell: createNumberRenderer('GBP'),
  },
  YEN: {
    renderEditor: NumberEditor,
    renderCell: createNumberRenderer('JPY'),
  },
  WON: {
    renderEditor: NumberEditor,
    renderCell: createNumberRenderer('KRW'),
  },
  RUBLE: {
    renderEditor: NumberEditor,
    renderCell: createNumberRenderer('RUB'),
  },
  YUAN: {
    renderEditor: NumberEditor,
    renderCell: createNumberRenderer('CNY'),
  },

  DATE: {
    renderEditor: DateEditor,
    renderCell: (value: Date | undefined) =>
      value
        ? `${value.getDate()}/${value.getMonth() + 1}/${value.getFullYear()}`
        : '',
  },

  SELECT: {
    renderEditor: SelectEditor,
    renderCell: selectRenderer,
  },
}

export default COLUMN_TYPES
